import React from 'react'
import { render } from 'react-dom'
import { ParallaxProvider } from 'react-scroll-parallax'
import smoothscroll from 'smoothscroll-polyfill'
import App from './components/App'

smoothscroll.polyfill()
document.addEventListener('DOMContentLoaded', () => {
    render(
        <ParallaxProvider>
            <App />
        </ParallaxProvider>,
        document.getElementById('root')
    )
})
